import React from "react";
import { Phone, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

const MobileStickyCTA = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-[#15161C]/95 backdrop-blur-md border-t border-[#2A2B32] p-2.5" data-testid="mobile-sticky-cta">
      <div className="flex space-x-2">
        <a
          href="tel:863-340-9244"
          className="flex-1 flex items-center justify-center space-x-2 bg-white/10 border border-[#2A2B32] text-white py-3 rounded-xl font-semibold text-sm"
          data-testid="mobile-sticky-call-btn"
        >
          <Phone size={18} />
          <span>Call Now</span>
        </a>
        <Link
          to="/booking"
          className="flex-1 flex items-center justify-center space-x-2 gradient-btn py-3 rounded-xl font-semibold text-sm"
          data-testid="mobile-sticky-book-btn"
        >
          <Calendar size={18} />
          <span>Free Estimate</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
